export default __webpack_public_path__ + "static/media/closeWhite.6622a569.svg";